import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import {AuthService} from '../../services/auth.service';
import {  NbToastrService, NbGlobalPosition, NbComponentStatus } from '@nebular/theme';

@Component({
  selector: 'buy-tariff-modal-loader',
  templateUrl: './buy-tariff-modal.component.html',
  styleUrls: ['./buy-tariff-modal.component.scss']
})
export class BuyTariffModalComponent implements OnInit, OnDestroy{


	@Input() tariffCode:string = 'start';
        dataLoader$:any = null
        loading:boolean = false

	tariffs = {  };


	currentTariff  = null
        months = [{months: 1, percentages: 0},{months: 3, percentages: 5},{months: 6, percentages: 15},{months: 12, percentages: 30}]

	currentMonths = null


 
	constructor(protected ref: NbDialogRef<BuyTariffModalComponent>, private authService: AuthService, private toastrService: NbToastrService ){  }
        

 	ngOnInit(){
		 
		for(let item of this.authService.tariffsList){
		  this.tariffs[item.shortCode] = { shortDescription: item.shortDescription ,pricePerMonth: item.price, code: item.shortCode, label: item.title, _id: item._id  }
		} 

		
		this.currentTariff = this.tariffs[this.tariffCode]
 
		this.currentTariff.shortDescription = this.currentTariff.shortDescription[0].charAt(0).toUpperCase() + this.currentTariff.shortDescription.slice(1)


		
		if(!this.currentTariff ) {this.ref.close(); return }

		this.currentMonths = this.months[0]

	}

        closeDialog(){
		this.ref.close()
	}


	 get pricePerMonth(){
	
		return  this.currentTariff.pricePerMonth

        }

 
	 get pricePerMonthCurrent(){
		/* let price = 0

		if(!this.currentMonths.percentages){
			return  this.currentTariff.pricePerMonth
		} else{
		price = (this.currentTariff.pricePerMonth - (this.currentTariff.pricePerMonth * (this.currentMonths.percentages / 100) ) )
		}
		return Math.round(price)  //%  1 === 0 ? price : price.toFixed(2)
		*/
		return  this.currentTariff.pricePerMonth
        }

       get totalPrice(){

	// let price = this.pricePerMonthCurrent * this.currentMonths.months 
		
		/* if(!this.currentMonths.percentages){

         	  price = this.currentTariff.pricePerMonth * this.currentMonths.months

		} else {

		  price = (this.currentTariff.pricePerMonth - (this.currentTariff.pricePerMonth * (this.currentMonths.percentages / 100) ) ) * this.currentMonths.months 

		} */
	
	 return this.pricePerMonthCurrent * this.currentMonths.months  // price //%  1 === 0 ? price : price.toFixed(2)

      }



     submit(){

	//this.closeDialog()

	this.loading = true;

	
	
	//setTimeout(()=>{this.loading = false;},3000)
	

	if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}
 
	//, this.currentMonths.months, window.location.pathname
	 this.dataLoader$ = this.authService.requestBuyTariff(this.currentTariff._id).subscribe((data)=>{


		this.loading = false;  
			/*   
			 if(data.response_status === 'success' && data.checkout_url){
				 window.location = data.checkout_url

			 } 


			if(data.tariffBound === true && data.tariff){

				this.authService.currentTariff = data.tariff

			} */

			if(data.error === true){
				this.showToastCopyClipboard(data.message, 'danger');
			}  

                        this.closeDialog()

		},()=>{this.loading = false; this.showToastCopyClipboard('Сталася помилка', 'danger');})		





     }



	  	
	   showToastCopyClipboard(text, status = 'primary'){

	    this.toastrService.show('',text,{
	      status: <NbComponentStatus>status,
	      icon: '',
	      position: <NbGlobalPosition>'bottom-end'
		})
	   }



	ngOnDestroy(){
		if(this.dataLoader$){this.dataLoader$.unsubscribe(); this.dataLoader$ = null}
	}


}
